import React from 'react';
import { PropTypes } from 'prop-types';
import BulbOnIcon from './BulbOnIcon';
import GraduationCap from './GraduationCap';
import GrabLogo from './GrabLogo';
import GrabForGood from './GrabForGoodLogo';
import GrabXNasAcademyIcon from './GrabXNasAcademyIcon';
import PlayIcon from './PlayIcon';
import MXTakaTakIcon from './MXTakaTakIcon';
import MXTakaTakXNasAcademyIcon from './MXTakaTakXNasAcademyIcon';
import MXIndividualsIcon from './MXIndividualsIcon';
import MXCreatorsIcon from './MXCreatorsIcon';
import UserGroupIcon from './UserGroupIcon';
import EyeVisible from './EyeVisible';
import MilestoneDotIcon from './MilestoneDotIcon';
import CrownIcon from './CrownIcon';
import FlagIcon from './FlagIcon';

const Icon = ({ name, ...props }) => {
  switch (name) {
    case 'bulb-on':
      return <BulbOnIcon {...props} />;
    case 'graduation-cap':
      return <GraduationCap {...props} />;
    case 'grab-logo':
      return <GrabLogo {...props} />;
    case 'grab-for-good':
      return <GrabForGood {...props} />;
    case 'grabxnas-academy':
      return <GrabXNasAcademyIcon {...props} />;
    case 'play':
      return <PlayIcon {...props} />;
    case 'mx-takatak':
      return <MXTakaTakIcon />;
    case 'mx-takatak-nas-academy':
      return <MXTakaTakXNasAcademyIcon />;
    case 'for-individuals-mx':
      return <MXIndividualsIcon />;
    case 'for-creators-mx':
      return <MXCreatorsIcon />;
    case 'user-group':
      return <UserGroupIcon />;
    case 'eye-visible':
      return <EyeVisible />;
    case 'milestone-dot':
      return <MilestoneDotIcon />;
    case 'crown':
      return <CrownIcon />;
    case 'flag':
      return <FlagIcon />;
    default:
      return null;
  }
};

Icon.propTypes = {
  name: PropTypes.string.isRequired,
};

export default Icon;
